import styled from 'styled-components';
import { Colors } from '@fourthwall/components';
export const Container = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.GS300};
  color: ${Colors.GS600};
  padding: 1px 6px;
  border-radius: 4px;

  font-size: 12px;
  font-weight: 600;
  line-height: 130%;
`;
